class SpeechmaticsAudio {
    /**
     * @param allowedMimeTypes Array of allowed mime types in string format,
     *                         for example 'audio/webm;codecs=opus'
     */
    constructor(allowedMimeTypes) {
        this.allowedMimeTypes = allowedMimeTypes
        this.selectedDeviceId = null
        this.mediaRecorder = null
        this.microphoneStream = null
        this.ondataavailable = null
    }

    /**
     * Select microphone to use in recording
     * @param deviceId Id of selected microphone device
     */
    setSelectedDevice(deviceId) {
        this.selectedDeviceId = deviceId
    }

    /**
     * Get first matched supported mime type
     * @returns First matched supported mime type
     */
    getSupportedMimeType() {
        for (const type of this.allowedMimeTypes) {
            if (MediaRecorder.isTypeSupported(type)) {
                return type;
            }
        }

        throw Error("No supported audio formats available")
    }

    /**
     * @throws Error
     */
    async record() {
        this.microphoneStream = await navigator.mediaDevices.getUserMedia({
            audio: this.selectedDeviceId ? {
                deviceId: {
                    exact: this.selectedDeviceId,
                }
            } : {
                deviceId: undefined
            },
        })

        const options = {
            mimeType: this.getSupportedMimeType()
        }

        this.mediaRecorder = new MediaRecorder(this.microphoneStream, options)

        this.mediaRecorder.ondataavailable = (event) => {
            this.ondataavailable?.(event)
        }
        this.mediaRecorder.start(500)
    }

    stop() {
        this.mediaRecorder?.stop()
        try {
            if (this.microphoneStream) {
                this.microphoneStream.getTracks()[0].stop();
                this.microphoneStream = null;
            }
        } catch (ex) {
            console.log(ex);
            // This fails in some older versions of chrome. Nothing we can do about it.
        }
        this.mediaRecorder = null
    }
}

export default SpeechmaticsAudio
